'use client';

import { useCallback, useEffect, useState } from 'react';

/** '다시 보지 않기'를 누른 사용자의 영구 숨김 기록. 값이 'true' 면 팝업을 열지 않는다. localStorage 에 둔다. */
export const POINT_NOTATION_NOTICE_HIDDEN_KEY = 'pointNotationNotice-hidden';

export const usePointNotationNotice = (): {
  isOpen: boolean;
  close: () => void;
  neverShowAgain: () => void;
} => {
  // SSR 과 첫 클라이언트 렌더가 어긋나지 않도록 false 로 시작하고, 마운트 후에 연다.
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    try {
      if (window.localStorage.getItem(POINT_NOTATION_NOTICE_HIDDEN_KEY) === 'true') return;
    } catch {
      // 사파리 프라이빗 모드 등에서 storage 접근이 throw 할 수 있다 — 읽지 못하면 열린 채로 둔다.
    }

    setIsOpen(true);
  }, []);

  // X 는 이 화면에서만 닫는다 — 아무것도 저장하지 않으므로 새로고침하면 다시 뜬다.
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  // '다시 보지 않기' — 닫고 영구히 숨긴다. 탭을 닫아도 유지돼야 해서 localStorage 에 둔다.
  const neverShowAgain = useCallback(() => {
    setIsOpen(false);

    try {
      window.localStorage.setItem(POINT_NOTATION_NOTICE_HIDDEN_KEY, 'true');
    } catch {
      // 저장에 실패해도 팝업은 닫는다 — 새로고침 시 다시 뜰 뿐이다.
    }
  }, []);

  return { close, isOpen, neverShowAgain };
};
